import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { O365AuthService } from '../../../services/o365-auth.service';

@Component({
  selector: 'app-access-denied',
  imports: [],
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.scss'
})
export class AccessDeniedComponent {
  constructor(private msalService: MsalService, private router: Router,
    private authService: O365AuthService) { }

  get signedIn(): boolean {
    return this.authService.signedIn;
  }

  get username(): string | null {
    return this.authService.username;
  }

  get userroles(): string[]   {
    return this.authService.userRoles();
  }    
}
